<template>
  <div class="content">
    <div class="block block-rounded block-fx-shadow">
      <div class="block-header">
        <h3 class="block-title">{{ $t('departures.contactfaces') }}</h3>
      </div>
      <table class="table table-hover table-bordered bg-white table-striped table-responsive">
          <thead>
              <th>#</th>
              <th>{{ $t('addresses.address') }}</th>
              <th>{{ $t('departures.user_id') }}</th>
              <th>{{ $t('departures.created_at') }}</th>
              <th>{{ $t('departures.status_name') }}</th>
              <th>{{ $t('departures.result_dialog')}}</th>
              <th>{{ $t('debts.next_contact_short') }}</th>
              <th>{{ $t('departures.promised_amount') }}</th>
              <th>{{ $t('departures.promised_date') }}</th>
              <th>{{ $t('app.comment') }}</th>
              <th>{{ $t('app.action') }}</th>
          </thead>
          <tbody>
            <template v-if="!load">
              <tr v-for="(departure, index) in departures" :key="departure.id">
                <td>{{index+1}}</td>
                <td>{{departure.address.address}}</td>
                <td>{{departure.user ? `${departure.user.firstname} ${departure.user.lastname}`: '' }}</td>
                <td>{{departure.created_at| datetimeFormat }}</td>
                <td>{{departure.status != null ? departure.status.name: '' }}</td>
                <td>{{departure.result_dialog ? departure.result_dialog.name: 'Не выбрано' }}</td>
                <td>{{departure.next_contact| dateFormat }}</td>
                <td>{{departure.promised_payment.amount}}</td>
                <td>{{departure.promised_payment.promised_date| dateFormat }}</td>
                <td>{{departure.comment}}</td>
                <td>
                  <button @click.prevent="handleDelete(departure.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" >
                    <i class="fa fa-times-circle"></i>
                  </button>
                </td>
              </tr>
            </template>
            <tr v-if="load">
              <td colspan="11" class="text-center">
                  <loader-wave/>
              </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departures: [],
      errors: [],
      message: '',
      isProcessing: false,
      load: false,
    };
  },
  mounted() {
    this.fetchDepartures();
  },
  methods: {
    fetchDepartures() {
      this.load = true;
      window.axios.get('/admin/departures/contactface')
        .then((res) => {
          this.departures = res.data.departures;
          this.load = false;
        });
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteDeparture(id);
        }
      });
    },

    deleteDeparture(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/departures/contactface/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchDepartures();
          }
          this.isProcessing = false;
        });
    },
  },
};
</script>
